import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../utils/firebase';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from 'react-toastify'
import Terms from './Terms';
import { checkEmpty, getAuthErrorMessage, spinner, makeid, convertDate } from "../utils/Helper"

// import firebase
import { getFirestore, collection, getDocs, setDoc, doc, query, where } from 'firebase/firestore'

const SignUp = ({ onSendToParent }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [completeFields, setCompleteFields] = useState('')
    const db = getFirestore()
    const [membershipLevels, setMembershipLevels] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const fetchMembershipRules = async () => {
        const snap = await getDocs(collection(db, "membership_levels"));
        const levelsArray = [];

        snap.forEach(doc => {
            const data = doc.data();
            // Only add to the list if addRegistration is true
            if (data.addRegistration === true) {
                levelsArray.push({ id: doc.id, ...data });
            }
        });

        setMembershipLevels(levelsArray);
    };

    fetchMembershipRules();

    const onSubmit = async (e) => {
        if (!checkEmpty(name) && !checkEmpty(email) && !checkEmpty(password) && !checkEmpty(selectedLevel)) {
            e.preventDefault()
            await createUserWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    toast.success("Account created successfully! Please log in.")
                    if (!checkEmpty(userCredential.user.email)) {
                        Login()
                    }
                })
                .catch((error) => {
                    toast.error(getAuthErrorMessage(error.code));
                });

        } else {
            toast.error("Please complete all of the fields...")
        }
    }

    async function createADoc(email, name) {
        spinner(true)
        const expirationDate = convertDate(new Date())
        const db = getFirestore()
        const id = makeid(12)
        await setDoc(doc(db, "profiles", id), {
            type: selectedLevel,
            email: email,
            expirationDate: expirationDate,
            id: id,
            name: name,
            details: '',
            filex: '',
            contact: '',
            board: false,
            cell: '',
            title: '',
            member: false,
            isAdmin: false,
        }).then(() => {
            toast.success("Member Document Created...")
            onSendToParent(true)
            spinner(false)
        }).catch(err => {
            toast.error(err.message)
            spinner(false)
        })
    }

    const getProfileDoc = async () => {
        spinner(true);
        const db = getFirestore()
        const ref = collection(db, "profiles")
        try {
            const q = query(ref, where('email', "==", localStorage.getItem('email')));
            const querySnapshot = await getDocs(q);
            const accessProfile = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            if (!checkEmpty(accessProfile[0].email)) {
                onSendToParent("profile")
            }
            spinner(false);
        } catch (error) {
            spinner(false);
            createADoc(localStorage.getItem('email'), name);
        }
    };

    function Login() {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                localStorage.setItem("isAnon", userCredential.user.isAnonymous)
                localStorage.setItem("email", userCredential.user.email)
                getProfileDoc()
            }).catch((error) => {
                toast.error(getAuthErrorMessage(error.code));
            });
    }

    const sendToParentUser = (data) => {
        onSendToParent("UserX")
    }

    const callTerms = () => {
        setCompleteFields("")
        if (!checkEmpty(name) && !checkEmpty(email) && !checkEmpty(password)) {
            setShow(true)
        } else {
            setCompleteFields("You must complete all fields")
        }
    }

    return (
        <main>
            <section className='border-0'>
                <div><h2 className="apc padding animated fadeInRight modified-apc">APC </h2>
                    <span className="xTitleSmall animated fadeInLeft white">Albuquerque Press Club</span></div>
                <h3 className="auth-title">Sign Up</h3>
                <form>
                    <div className="error-text"><strong className="red">{completeFields}</strong></div>
                    <div className="custom-select-container">
                        <label className="form-control-label">Membership Level</label>
                        <div
                            className="glass-input custom-select-trigger"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <span>{selectedLevel ? selectedLevel : "Select Membership Level"}</span>
                            <span className={`chevron ${isOpen ? 'up' : 'down'}`}>▼</span>
                        </div>

                        {isOpen && (
                            <div className="select-dropdown-overlay">
                                <div className="sheet-header">
                                    <h3 className="white">Select Level</h3>
                                    <button type="button" className="close-btn" onClick={() => setIsOpen(false)}>✕</button>
                                </div>
                                <div className="options-list">
                                    {membershipLevels.map((level) => (
                                        <div
                                            key={level.id}
                                            className={`option-item ${selectedLevel === level.id ? 'selected' : ''}`}
                                            onClick={() => {
                                                setSelectedLevel(level.id);
                                                setIsOpen(false);
                                            }}
                                        >
                                            <div className="option-title">{level.id}</div>
                                            <div className="option-desc">
                                                {/* Purple Sparkle Emoji */}
                                                <span style={{
                                                    marginRight: '8px',
                                                    color: '#bf5af2', /* Vibrant iOS-style purple */
                                                    fontSize: '1.1em'
                                                }}>
                                                    ✨
                                                </span>
                                                {level.description}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="auth-form-group">
                        <label className="meta-label" htmlFor="name">Full Name</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            className="form-control glass-input"
                            placeholder="Enter full name"
                            id="name"
                        />
                    </div>
                    <div className="auth-form-group">
                        <label className="meta-label" htmlFor="email">Email address</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="form-control glass-input"
                            placeholder="name@example.com"
                            id="email"
                        />
                    </div>
                    <div className="auth-form-group">
                        <label className="meta-label" htmlFor="password">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="form-control glass-input"
                            placeholder="Create password"
                            id="password"
                        />
                    </div>

                    <button
                        onClick={callTerms}
                        type="button"
                        className="btn-glass-save-edit w-100"
                        style={{ width: '100%', marginTop: '10px' }}
                    >
                        Create Account
                    </button>

                    <Modal
                        show={show}
                        onHide={handleClose}
                        centered
                        backdropClassName={"adminBackdrop"}
                        contentClassName={"bg-dark"}

                    >
                        <Modal.Header closeButton className="border-0">
                            <Modal.Title className="modified xTitleSmall" style={{ marginBottom: 0 }}>
                                Terms
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <Terms />
                            <ToastContainer theme="dark" />
                        </Modal.Body>
                        <Modal.Footer className="border-0 d-flex justify-content-between">
                            <Button onClick={onSubmit} className="btn-glass-save-edit">
                                Agree
                            </Button>
                            <Button className="btn-glass-create" onClick={handleClose}>
                                Decline
                            </Button>

                        </Modal.Footer>
                    </Modal>
                    <div className="auth-divider">
                        <hr />
                        <span>OR</span>
                    </div>

                    <div className="auth-footer">
                        <p className="meta-label" style={{ textAlign: 'center', marginBottom: '10px' }}>
                            Already have an account?
                        </p>
                        <button
                            onClick={sendToParentUser}
                            className="btn-glass-create w-100"
                            style={{ width: '100%' }}
                        >
                            Go To Login
                        </button>
                    </div>
                </form>
            </section>
        </main>
    )
}

export default SignUp